import React from 'react';
import {useSelector} from 'react-redux';
import {Navigate} from 'react-router';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import SummaryHeader from 'shared/ui/SummaryHeader/SummaryHeader';
import Email from 'images/emails.png';
import {useEmailConfirmation, userSelector, getEmailScreenPriority} from 'entities/user';
import {useDeadlineTimer} from 'shared/lib/hooks/useDeadlineTimer';
import useBreakpoint from 'shared/lib/hooks/useBreakpoint';
import {getDayWord} from 'shared/lib/format/pluralize';

import HeaderEmail from '../HeaderEmail/HeaderEmail';
import AnswerEmail from '../AnswerEmail/AnswerEmail';

import styles from './EmailDelete.module.scss';

const EmailDelete: React.FC = () => {
    const user = useSelector(userSelector);
    const deadlineDate = user?.confirm_email_deadline;
    const confirmEmail = useEmailConfirmation();
    const breakpoint = useBreakpoint();
    const timeLeft = useDeadlineTimer(deadlineDate);

    const priority = getEmailScreenPriority(user);

    if (priority !== 'delete') {
        return <Navigate to="/monitors" replace />;
    }

    const emailBold = <span className={styles.bold}>{user?.email}</span>;
    const buttonText = breakpoint === 'large' || breakpoint === 'medium'
        ? t`Запросить письмо подтверждения`
        : t`Запросить письмо`;

    return (
        <section className={styles.section}>
            <SummaryHeader />
            <HeaderEmail
                title={t`Для завершения регистрации подтвердите почту!`}
                onClick={confirmEmail}
                buttonText={buttonText}
                icon={Email}
                button
            >
                <div>{t`Учетная запись без подтвержденной почты`} {emailBold}{' '}
                    <span className={styles.red}>{t`будет удалена через`}:</span>
                </div>
                <div className={styles.date}>
                    <div className={styles.contentDate}>
                        <span className={styles.textDate}>{timeLeft.days}
                            <span className={styles.day}>&nbsp;{getDayWord(timeLeft.days)}</span>
                        </span>
                        <span className={cn(styles.textDate, styles.time)}>
                            {String(timeLeft.hours).padStart(2, '0')}:
                            {String(timeLeft.minutes).padStart(2, '0')}:
                            {String(timeLeft.seconds).padStart(2, '0')}
                        </span>
                    </div>
                </div>
                <div className={styles.red}>{t`Если письма нет, проверьте папку`}
                    <span className={styles.bold}> «{t`Спам`}»</span>
                </div>
            </HeaderEmail>
            <AnswerEmail className={styles.button}/>
        </section>
    );
};

export default EmailDelete;